export default function MySQL_DATE_FORMAT() {
  return (
    <div>
      <h2>MySQL_DATE_FORMAT</h2>    </div>
  );
}